import { jsx as _jsx } from "react/jsx-runtime";
import { Form, Select } from "antd";
import { getCookieTypeLocalizationMap } from "@devowl-wp/react-cookie-banner";
import { useI18n } from "../../../../../../../contexts/i18n.js";
const FormServiceFieldTechnicalDefinitionsCookieType = ({ field, readOnly = false })=>{
    const { __ } = useI18n();
    const cookieTypeLocalized = getCookieTypeLocalizationMap();
    return /*#__PURE__*/ _jsx(Form.Item, {
        name: [
            field.name,
            "type"
        ],
        noStyle: true,
        rules: [
            {
                required: true,
                message: __("Please provide a cookie type!")
            }
        ],
        children: /*#__PURE__*/ _jsx(Select, {
            disabled: readOnly,
            children: Object.keys(cookieTypeLocalized).map((key)=>/*#__PURE__*/ _jsx(Select.Option, {
                    value: key,
                    style: {
                        display: key === "flash" ? "none" : undefined
                    },
                    children: cookieTypeLocalized[key].name
                }, key))
        })
    });
};
export { FormServiceFieldTechnicalDefinitionsCookieType };
